import classNames from 'classnames';
import React from 'react';
import SidebarAccordion from './SidebarAccordion';
import SidebarItem from './SidebarItem';
import ChevronDown from '@/icons/ChevronDown';

const Sidebar = ({ items }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <nav
      className={classNames('sidebar__nav', {
        'sidebar__nav--open': open,
      })}
      id="sidebar-nav"
    >
      <button
        type="button"
        className="h4 sidebar__nav-title"
        onClick={() => setOpen(!open)}
      >
        Browse topics
        <ChevronDown width={11} />
      </button>

      {items.length > 0 && (
        <ol
          className="sidebar__list sidebar__list--root"
          tabIndex={open ? 0 : -1}
        >
          {items.map((item) => (
            <li
              className={classNames(
                'sidebar__list-item',
                item.linkingMode,
                item.subcategories.length > 0 &&
                  'sidebar__list-item--has-subcategories'
              )}
              key={item.title}
            >
              {item.subcategories ? (
                <SidebarAccordion {...item} />
              ) : (
                <SidebarItem {...item} />
              )}
            </li>
          ))}
        </ol>
      )}
    </nav>
  );
};

export default Sidebar;
